import type { UseMutationResult } from 'react-query';
import { useMutation, useQueryClient } from 'react-query';

import type { IApiDeleteUserBadgeResponseBody } from '../UserBadgesApi.types';
import { useApi } from '~/lib/api/useApi';
import { userBadgeQueryKeyFactory } from './useUserBadgeQuery';
import { userBadgesQueryKeyFactory } from './useUserBadgesQuery';

export type IUseDeleteUserBadgeMutationValues = {
  appId: string;
  userBadgeId: string;
};

export const useDeleteUserBadgeMutation = (): UseMutationResult<
  IApiDeleteUserBadgeResponseBody,
  unknown,
  IUseDeleteUserBadgeMutationValues
> => {
  const api = useApi();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (values: IUseDeleteUserBadgeMutationValues) =>
      api.userBadges.delete(values.appId, values.userBadgeId),
    onSuccess: async (_, values) => {
      [
        // TODO once the API is updated to return the deleted resources
        // data.deletedResources.userbadgeIds
        values.userBadgeId,
      ]
        .map((userBadgeId) => [
          {
            queryKey: userBadgeQueryKeyFactory({
              appId: values.appId,
              userBadgeId,
            }),
          },
        ])
        .flat()
        .forEach((filters) => queryClient.removeQueries(filters));

      await queryClient.invalidateQueries({
        queryKey: userBadgesQueryKeyFactory({
          appId: values.appId,
        }),
      });
    },
  });
};
